import { createWidget } from '@alfa-bank/site-util-create-widget';

import type { IDeps, TSmeCarouselDots } from './models';
import styles from './styles.css';
import { SmeCarouselDots as Component } from './dots';

export const SmeCarouselDots = createWidget<IDeps, TSmeCarouselDots>({
    styles,
})(Component);
